// extracted by mini-css-extract-plugin
export default {"container_external":"MenuMobileHamburger_container_external__BtQ05","scrolled":"MenuMobileHamburger_scrolled__XBufq","button":"MenuMobileHamburger_button__KuQtV"};